<template>
  <div class="message-textarea__wrap" :disabled="disabled">
    <!-- если используется не для отправки сообщений, а например для описания задачи и мероприятия в ленте-->
    <div v-if="notMessage"
         class="message-textarea"
         contenteditable="true"
         :style="`height: ${textareaHeight}`"
         :v-html="value"
         :placeholder="placeholder"
         :disabled="disabled"
         ref="input"
         @focus="focused"
         @mouseup="selectRange"
         @input="valueChanged"
         @paste="handlePaste"
         @drop.prevent="handleDrop"
    />
    <!--для отправки сообщений поведение сочетаний клавиш иное-->
    <div v-else
         class="message-textarea"
         contenteditable="true"
         :style="`height: ${textareaHeight}; padding: ${textareaPadding}`"
         :v-html="value"
         :placeholder="placeholder"
         :disabled="disabled"
         ref="input"
         @focus="focused"
         @mouseup="selectRange"
         @input="valueChanged"
         @paste="handlePaste"
         @drop.prevent="handleDrop"
         @keydown.enter.exact.prevent="sendMessage"
         @keydown.enter.ctrl.exact="''"
    />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'app-message-input',
  props: {
    value: String,
    placeholder: String,
    blurAfterSend: {
      type: Boolean,
      default: false
    },
    textareaHeight: {
      type: String,
      default: '80px'
    },
    notMessage: {
      type: Boolean,
      default: false
    },
    textareaPadding: {
      type: String,
      default: ''
    },
    disabled: Boolean
  },
  data () {
    return {}
  },
  methods: {
    valueChanged () {
      this.$emit('value-changed', this.$refs.input.innerHTML)

      const range = document.getSelection().getRangeAt(0).cloneRange()
      const data = {
        input: this.$refs.input,
        range: range
      }
      this.$emit('selection-range', data)
    },
    focused () {
      this.$emit('got-focus')
    },
    selectRange () {
      const range = document.getSelection().getRangeAt(0).cloneRange()
      const data = {
        input: this.$refs.input,
        range: range
      }
      this.$emit('selection-range', data)
    },
    sendMessage () {
      if (this.blurAfterSend) {
        this.$refs.input.blur()
      }
      this.$refs.input.innerHTML = ''
      this.$emit('send-message')
    },
    getFocus () {
      this.$refs.input.focus()
    },
    handlePaste (e) {
      if (!e.clipboardData.getData('text/plain')) {
        e.preventDefault()
        const pasteFiles = e.clipboardData.files
        if (pasteFiles?.length) {
          this.$emit('paste-files', [...pasteFiles])
        }
      }
    },
    handleDrop (e) {
      const dropFiles = e.dataTransfer.files
      if (dropFiles?.length) {
        this.$emit('paste-files', [...dropFiles])
      }
    }
  },
  mounted () {
    // событие чтобы можно было получить ссылку на инпут без selectRange
    this.$emit('input-reference', this.$refs.input)

    // watch недостаточно для случаев когда этот компонент идёт в составе "позже монтируемого" (например модалки)
    // поэтому проверяем и обновляем value из стейта
    if (this.value !== this.$refs.input.innerHTML) {
      this.$refs.input.innerHTML = this.value
    }
  },
  updated () {
    // при открытии для редактирования значение инпута не обновлялось, несмотря на то что value пришло новое
    // пофиксил таким образом
    // watch отрабатывал неправильно (переставляя каретку в начало при каждом вводе)
    if (this.value !== this.$refs.input.innerHTML) {
      this.$refs.input.innerHTML = this.value
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.message-textarea {
  display: block;
  width: 100%;
  padding: 10px 16px 10px 16px;
  background: $color_main;
  color: $font_color_second;
  /*border: 1px solid $color_third-dark;*/
  /*border-radius: 3px;*/
  transition: .3s;
  font: inherit;
  overflow: auto;
  word-break: break-all;

  &__wrap {
    position: relative;
    display: block;

    &[disabled] {
      pointer-events: none;

      .textarea__text {
        color: $color_deactive;
      }

      .textarea {
        /*border: 1px solid $color_deactive;*/
        background-color: $color_deactive-bg;
      }
    }
  }

  &__text {
    color: $font_color_second;
    display: block;
    margin-bottom: 10px;
  }

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-button {
    height: 8px;
    opacity: 0;
  }

  &::-webkit-scrollbar-track {
    background: linear-gradient(90deg, $border-color 0%, $border-color 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(90deg, $color_second-light 0%, $color_second-light 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
  }

  &:hover {
    /*border: 1px solid $color_second-light;*/
  }

  &:focus {
    /*box-shadow: inset 0 4px 4px rgba(23, 63, 125, 0.25);*/
  }
}
</style>
